<template>
<div class="wlx-managerWordList-web">
    <div class="clearfix">
        <div class="wl-certification-content">
            <div class="authen-hade-title clearfix">
                <h3 class="h3-text-title">
                    <span>管理办法</span>
                </h3>
                <div class="authen-hade-crumbs">
                    <i class="wl-icon-zhuye1"></i>
                    <span>当前位置：</span>
                    <span @click="goHome">网站首页</span>
                    <span>></span>
                    <span>管理办法</span>
                </div>
            </div>
            <div class="pc-list-con">
                <div class="new-center-list clearfix" v-for="(item,index) in list" :key="index">
                    <div class="new-center-li clearfix" @click="goNewsDetail(item.id)">
                        <div class="li-back-date">
                            <p class="date-class">{{item.date}}</p>
                            <p>{{item.month}}</p>
                        </div>
                        <div class="new-center-left">
                            <p class="text-title">{{item.title}}</p>
                            <p class="text-detail" v-html="item.contentText"></p>
                        </div>
                    </div>
                </div>
                <div class="banner-page-con" v-show="total>0">
                    <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
                <div v-if="noDataShow" class="yk-nodata-source-content">
                    <img src="~assets/images/the-last-new-nodata-imag.png" alt class="yk-prompt">
                </div>
            </div>
            <div class="ph-list-con">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-if="list.length > 0">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
                        <div class="new-center-list clearfix" v-for="(item,index) in list" :key="index">
                            <div class="new-center-li clearfix" @click="goNewsDetail(item.id)">
                                <div class="li-back-date">
                                    <p class="date-class">{{item.date}}</p>
                                    <p>{{item.month}}</p>
                                </div>
                                <div class="new-center-left">
                                    <p class="text-title">{{item.title}}</p>
                                    <p class="text-detail" v-html="item.contentText"></p>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
                <div class="no-data-tip-con" v-else>
                    <img src="~assets/images/the-last-new-nodata-imag.png" alt>
                </div>
            </div>
        </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="预览" :visible.sync="dialogVisiblePreviewResources" width="60%" :append-to-body="true">
        <img :src="imgUrl" alt="" class="preview-img-class">
        <span slot="footer" class="dialog-footer">
            <el-button @click="pre()">上一页</el-button>
            <el-button @click="next()">下一页</el-button>
            <el-button @click="dialogVisiblePreviewResources = false">关 闭</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            isTab: 1,
            back: require("assets/images/bg-jieshao.png"),
            TeaAuthenticaList: [],
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            noDataShow: false,
            dialogVisiblePreviewResources: false,
            imgUrl: "",
            imgsList: [],
            indexCount: 0,
            certifyIdValue: '',
            refreshing: false,
            finished: false,
            loading: false
        };
    },
    watch: {
        certifyId(val) {
            this.certifyIdValue = val;
            this.getManagerWordList();
        }
    },
    props: {
        certifyId: {
            type: String,
            default: ''
        }
    },
    created() {
        this.certifyIdValue = this.certifyId;
        this.getManagerWordList();
    },
    methods: {
        onRefresh() {
            this.refreshing = true;
            this.getManagerWordList();
        },
        onLoad() {
            this.pageSize += 10;
            this.getManagerWordList();
        },
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
        getManagerWordList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ManagerWordCom/getManagerWordList", {
                    type: this.type,
                    certificateId: this.certifyIdValue,
                    page: this.pageIndex,
                    pageSize: this.pageSize
                })
                .then(function (rst) {
                    if (rst.code == 1) {
                        that.refreshing = false;
                        that.loading = false;
                        that.list = rst.list;
                        that.total = rst.pagination.totalCount;
                        that.pageSize = rst.pagination.pageSize;
                        that.pageIndex = rst.pagination.pageIndex;
                        if (that.list.length == that.total) {
                            that.finished = true;
                        }
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        onPageChangeHandler(page) {
            this.pageIndex = page;
            this.getManagerWordList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getManagerWordList();
        },
        goNewsDetail(managerWordId) {
            this.$router.push({
                name: "managerWordDetail",
                params: {
                    managerWordId: managerWordId
                }
            });
        },
        // 预览文件
        see(docId, docUrl) {
            var that = this;
            this.$http
                .post("/api/XOrg/AttestationActivity/getScreenCourseWareInfo", {
                    courseWareId: docId
                })
                .then(function (rst) {
                    var data = [];
                    // 判断是否是单张图片
                    if (rst.category != "jpg" && rst.category != "jpeg" && rst.category != "png" && rst.category != "gif") {

                        var statusUrl = rst.urls.preview_oss_gen;

                        // 拼接图片的地址
                        for (var i = 0; i < rst.args_page_count; i++) {
                            data.push(statusUrl + (i + 1) + ".png");
                        }
                    } else {
                        data = [docUrl];
                    }
                    if (rst.status == 1) {
                        that.dialogVisiblePreviewResources = true;
                        that.imgsList = data
                        that.imgUrl = data[0];
                    } else {
                        that.$message.warning("文件正在转换，请稍等");
                    }
                });
        },
        pre() {
            if (this.indexCount > 0) {
                this.indexCount -= 1;
                this.imgUrl = this.imgsList[this.indexCount];
            }
        },
        next() {
            if (this.indexCount < this.imgsList.length - 1) {
                this.indexCount += 1;
                this.imgUrl = this.imgsList[this.indexCount];
            }
        }
    }
};
</script>

<style lang="scss">
.wlx-managerWordList-web {
    .border-class-content {
        .p-down-file-con-title {
            cursor: pointer;
            line-height: 30px;
        }

        .banner-page-con {
            margin-top: 20px;
        }
    }

    .authen-hade-title {
        margin-bottom: 30px;
    }

    .new-center-list {
        border-bottom: 1px solid #D9D9D9;
        padding: 0 40px 30px 40px;
        margin-bottom: 30px;

        .new-center-li {
            cursor: pointer;
        }

        .li-back-date {
            float: left;
            width: 70px;
            height: 65px;
            background: rgba(45, 130, 255, 1);
            text-align: center;
            font-size: 13px;
            color: #fff;

            .date-class {
                font-size: 24px;
                margin: 6px 0;
            }
        }

        .new-center-left {
            float: left;
            margin-left: 30px;
            width: calc(100% - 100px);

            .text-title {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold;
                font-weight: bold;
                margin-bottom: 10px;
                margin-top: 4px;
            }

            .text-detail {
                font-size: 13px;
                height: 37px;
                font-family: MicrosoftYaHei;
                color: #606060;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 1.5;

                img {
                    display: none;
                }
            }
        }
    }

    .new-center-li:hover {
        .text-title {
            color: #2D82FF;
        }
    }

    .preview-img-class {
        max-width: 100%;
    }

    .pc-list-con {
        display: block;
    }

    .ph-list-con {
        display: none;
    }
}

@media only screen and (max-width:960px) {
    .wlx-managerWordList-web {
        .new-center-list {
            margin: 10px 0;
            padding: 0 0 10px 0;

            .new-center-li {}
        }

        .pc-list-con {
            display: none;
        }

        .ph-list-con {
            display: block;
        }
    }
}
</style>
